import { Component } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { Header } from './header/header.component';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { TokenInterceptor } from './helpers/token.interceptor';
import { ToastrModule } from 'ngx-toastr';
import { IdleTimeoutService } from './services/idle-timeout.service';
import { AddressVerificationBannerComponent } from './address-verification-banner/address-verification-banner.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, Header, CommonModule, AddressVerificationBannerComponent],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  constructor(
    public router: Router,
    private idleTimeoutService: IdleTimeoutService
  ) {}
  title = 'connect';

  get isAuthPage(): boolean {
    // The set-password link carries its token in the fragment and an email
    // client may add a query string, so that page is matched by its path alone.
    return this.router.url.split(/[?#]/)[0] === '/set-password' ||
      this.router.url === '/login' ||
      this.router.url === '/forgotpassword' ||
      this.router.url === '/createaccount' ||
      this.router.url === '/thanks';
  }

  ngOnInit() {
    document.body.style.backgroundColor = '#FAFBFD';
  }
}
